export default function Download(props) {
    const fill = props.fill ?? '#212121';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                d="M410 279L256 432 102 279l28-29 106 106V0h40v356l106-106zm102 193H0v40h512zm0 0"
                fill={fill}
            />
        </svg>
    );
}
